// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3qs0c","clinicsSelect":"TableHeading_clinicsSelect__1hb7j"};